import {
  Box,
  Button,
  FieldSlider,
  FieldText,
  FormField,
  FormGrid,
  Page,
} from '@dixa/lib-shared-habla';
import { PureComponent } from 'react';
import { Field, InjectedFormProps } from 'redux-form';

import { FieldDuration } from 'fable/fieldDuration';
import { FieldToggleBoxHead, ToggleBox, ToggleBoxBody } from 'fable/toggleBox';

import {
  availableAgentsTooltipText,
  longestWaitTooltipText,
  slaPercentageTooltipText,
  waitingConversationsTooltipText,
} from './constants';

export const waitingConversationField = 'waiting_conversations';

export type QueuesAlertsFormValues = {
  is_sla_percentage: boolean;
  sla_percentage: number;
  sla_time_limit?: number;
  is_longest_wait: boolean;
  longest_wait: number;
  is_available_agents: boolean;
  available_agents?: number;
  is_waiting_conversations: boolean;
  waiting_conversations: number;
};

export type QueuesAlertsFormOwnProps = {
  isLoading?: boolean;
};

export type QueuesAlertsFormDispatchProps = {};
export type QueuesAlertsFormStateProps = {
  formValues: QueuesAlertsFormValues;
};

type QueuesAlertsFormState = {};

export type QueuesAlertsFormProps = QueuesAlertsFormOwnProps &
  QueuesAlertsFormDispatchProps &
  QueuesAlertsFormStateProps;

type InjectedProps = InjectedFormProps<
  QueuesAlertsFormValues,
  QueuesAlertsFormProps
>;

type PropsT = QueuesAlertsFormProps & InjectedProps;
export class QueuesAlertsForm extends PureComponent<
  PropsT,
  QueuesAlertsFormState
> {
  render() {
    const { formValues, pristine, submitting, isLoading, handleSubmit } =
      this.props;

    return (
      <form onSubmit={handleSubmit}>
        <Page.Section
          title="Alert thresholds"
          controls={
            <Button
              disabled={pristine || submitting || isLoading}
              isLoading={isLoading}
              type="submit"
            >
              Save
            </Button>
          }
        >
          <FormGrid>
            <FormField>
              <ToggleBox
                headComponent={FieldToggleBoxHead}
                isOpen={formValues.is_sla_percentage}
                title="Service-Level Alert"
                input={{
                  id: 'is_sla_percentage',
                  value: 'is_sla_percentage',
                  name: 'is_sla_percentage',
                }}
                helpIcon={{
                  title: 'Service-level',
                  text: slaPercentageTooltipText,
                }}
              >
                <ToggleBoxBody>
                  <Field
                    label="Service-level percentage"
                    name="sla_percentage"
                    component={FieldSlider}
                    valueSuffix="%"
                    parse={(v) => (typeof v === 'string' ? parseInt(v) : v)}
                  />
                  <Box padding="300 0 0 0">
                    <Field
                      name="sla_time_limit"
                      label="Service-level time limit"
                      component={FieldDuration}
                      noAlert
                    />
                  </Box>
                </ToggleBoxBody>
              </ToggleBox>
            </FormField>

            <FormField>
              <ToggleBox
                headComponent={FieldToggleBoxHead}
                isOpen={formValues.is_longest_wait}
                title="Current longest wait in a queue alert"
                input={{
                  id: 'is_longest_wait',
                  value: 'is_longest_wait',
                  name: 'is_longest_wait',
                }}
                helpIcon={{
                  title: 'Current longest wait in a queue',
                  text: longestWaitTooltipText,
                }}
              >
                <ToggleBoxBody>
                  <Field
                    name="longest_wait"
                    component={FieldDuration}
                    noAlert
                  />
                </ToggleBoxBody>
              </ToggleBox>
            </FormField>

            <FormField>
              <ToggleBox
                headComponent={FieldToggleBoxHead}
                isOpen={formValues.is_available_agents}
                title="Available agents alert"
                input={{
                  id: 'is_available_agents',
                  value: 'is_available_agents',
                  name: 'is_available_agents',
                }}
                helpIcon={{
                  title: 'Available agents limit alert',
                  text: availableAgentsTooltipText,
                }}
              >
                <ToggleBoxBody>
                  <Field
                    label="Available agents limit"
                    name="available_agents"
                    type="number"
                    parse={(value) => parseInt(value, 10)}
                    component={FieldText}
                    noAlert
                  />
                </ToggleBoxBody>
              </ToggleBox>
            </FormField>

            <FormField>
              <ToggleBox
                headComponent={FieldToggleBoxHead}
                isOpen={formValues.is_waiting_conversations}
                title="Maximum waiting in queue alert"
                input={{
                  id: 'is_waiting_conversations',
                  value: 'is_waiting_conversations',
                  name: 'is_waiting_conversations',
                }}
                helpIcon={{
                  title: 'Maximum conversations in queue',
                  text: waitingConversationsTooltipText,
                }}
              >
                <ToggleBoxBody>
                  <Field
                    component={FieldText}
                    label="Maximum waiting in queue"
                    max={500}
                    min={0}
                    name={waitingConversationField}
                    parse={(value: string) => (value ? parseInt(value, 10) : 0)}
                    type="number"
                  />
                </ToggleBoxBody>
              </ToggleBox>
            </FormField>
          </FormGrid>
        </Page.Section>
      </form>
    );
  }
}
